import React, { useState } from 'react';
import { InfoIcon, Modal, Tooltip } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Parameter is item for displaying label/value
 * TODO: check if parameter is joinable with ProductParameters from ui-toolkit
 */

const TooltipPopup = (Message) => {
  const [isOpened, setIsOpened] = useState(false);
  return (
    <>
      <span
        aria-label="Дополнительная информация"
        name="Дополнительная информация"
        onClick={() => setIsOpened(true)}
        role="button"
        tabIndex={0}
      >
        <InfoIcon fill="#727281" size="s" />
      </span>
      <Modal isOpen={isOpened} onClose={() => setIsOpened(!isOpened)} size="s">
        {Message?.message}
      </Modal>
    </>
  );
};
export const Parameter = ({
  children = '',
  className,
  isFirst,
  isLabelCollapsed,
  isLast,
  isMobile,
  label,
  tip,
  url,
}) => {
  const hasUrl = url && url.length !== 0;
  return (
    <div
      className={cx(
        'component',
        className,
        isMobile ? 'mobile' : null,
        isLast && 'noBorder',
        isFirst && 'firstParam',
      )}
    >
      <div className={cx('label', { collapsed: isLabelCollapsed })}>
        {label && parseHtmlToReact(label)}
        <span className={cx('tooltip')}>
          {tip && !isMobile && (
            <Tooltip message={tip}>
              <InfoIcon fill="#727281" size="s" />
            </Tooltip>
          )}
          {tip && isMobile && <TooltipPopup message={tip} />}
        </span>
      </div>
      <div className={cx('value')}>
        {hasUrl ?
          <a className={cx(hasUrl && 'link')} href={url}>
            {parseHtmlToReact(children)}
          </a>
        : parseHtmlToReact(children)}
      </div>
    </div>
  );
};

Parameter.propTypes = {
  children: PropTypes.node, // represents parameter value
  className: PropTypes.any,
  isFirst: PropTypes.bool,
  isLabelCollapsed: PropTypes.bool,
  isLast: PropTypes.bool,
  isMobile: PropTypes.bool,
  label: PropTypes.node, // represents parameter title/value
  tip: PropTypes.node, // represents parameter bubble
  url: PropTypes.string, // represents url to redirect
};
